var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Painter',{attrs:{"array":_vm.fabricObjectArray,"app-id":_vm.appId,"poster-key":_vm.posterKey}})}
var staticRenderFns = []

export { render, staticRenderFns }